import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DateFnsUtils from "@date-io/date-fns";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";

// Custom Component
import Legend from "../../../Legend/Legend";

import { ckEditorToolbar } from "../../../../global/ckEditor";

// Custom Style
import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));
const TransmittalComment = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    postCommentConfirmAction,
    xmtl_seq,
    submissionValue,
    commentvalidate,
    commentvalidationErrors,
    submissionCommentValue,
    setSubmissionCommentValue,
    userStageAction,
  } = props;

  // Handle Form Input
  const ckeditorHandleChange = (name) => (event, editor) => {
    const inputData = editor.getData();
    const data = { ...submissionCommentValue };
    data.xmtlcomment = inputData;
    setSubmissionCommentValue({ ...submissionCommentValue, ...data });
    dispatch({
      type: "ADD_TRANSMITTAL_COMMENT_SUBMISSION_VALUE",
      data: { ...submissionCommentValue, ...data },
    });
    if (
      commentvalidationErrors.xmtlcomment &&
      commentvalidationErrors.xmtlcomment !== ""
        ? true
        : false
    ) {
      commentvalidate({ ...submissionCommentValue, xmtlcomment: inputData });
    }
  };

  // CKEditor Config
  const editorConfiguration = {
    toolbar: ckEditorToolbar,
  };

  return (
    <Fragment>
      <Grid item xs={12}>
        <Box border={1} borderColor={"grey.500"} className={classes.boxArea}>
          <Typography variant="subtitle1" className={classes.headerText}>
            Comment Information
          </Typography>
          <Divider className={classes.divider} />
          <Typography variant="subtitle1" className={classes.subHeaderText}>
            History of Comment:
          </Typography>
          {submissionValue.comments && submissionValue.comments.length > 0 ? (
            submissionValue.comments.map((obj, index) => {
              return (
                <div key={index}>
                  <Grid item xs={12}>
                    <div className={classes.itemText}>
                      Comment by: {obj.createuser} At {obj.createdate}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <CKEditor
                      editor={ClassicEditor}
                      data={obj.xmtlcomment}
                      config={editorConfiguration}
                      disabled={true}
                    />
                  </Grid>
                  <br />
                </div>
              );
            })
          ) : (
            <h3 style={{ color: "red" }}>No History Comment</h3>
          )}
          {userStageAction.IS_COMMENTABLE === "Y" && (
            <>
              <Legend id="comment-content" label="Comment">
                <Box
                  border={
                    commentvalidationErrors.xmtlcomment &&
                    commentvalidationErrors.xmtlcomment !== ""
                      ? 1
                      : 0
                  }
                  borderColor={
                    commentvalidationErrors.xmtlcomment &&
                    commentvalidationErrors.xmtlcomment !== ""
                      ? "error.main"
                      : "grey.500"
                  }
                >
                  <CKEditor
                    editor={ClassicEditor}
                    data={submissionCommentValue.xmtlcomment || ""}
                    name={"comment"}
                    onChange={ckeditorHandleChange("comment")}
                    config={editorConfiguration}
                  />
                </Box>
                {commentvalidationErrors.xmtlcomment &&
                commentvalidationErrors.xmtlcomment !== "" ? (
                  <Typography
                    variant="caption"
                    color="error"
                    className={classes.errorMsg}
                  >
                    {commentvalidationErrors.xmtlcomment}
                  </Typography>
                ) : (
                  ""
                )}
              </Legend>
              <Button
                variant="contained"
                color="primary"
                className={classes.formBtn}
                onClick={() => postCommentConfirmAction(xmtl_seq)}
              >
                Post Comment
              </Button>
            </>
          )}
        </Box>
      </Grid>
    </Fragment>
  );
};

export default TransmittalComment;
